export const SHIFTS_PER_PAGE = 2000;

const ShiftSubType = {
  DraftOpenShift: 'DraftOpenShift',
  DraftVTO: 'DraftVTO',
  DraftInventory: 'DraftInventory',
  DraftUnregisteredInventory: 'DraftUnregisteredInventory',
  ParentOpenShift: 'ParentOpenShift',
  ChildOpenShift: 'ChildOpenShift',
  ParentVTO: 'ParentVTO',
  ChildVTO: 'ChildVTO',
  Inventory: 'Inventory',
  TeamShift: 'TeamShift',
  CalledOff: 'CalledOff',
  Unknown: 'Unknown',
};

const ShiftCreationType = {
  VTO: 'VTO',
  OpenShift: 'OpenShift',
  Inventory: 'Inventory',
}

const CardClassName = {
  card_inventory: 'card_inventory',
  card_called_off: 'card_called_off',
  card_approved: 'card_approved',
  card_posted: 'card_posted',
  card_pending: 'card_pending',
  card_unpublished: 'card_unpublished',
  card_denied: 'card_denied',
}

const detailStatusTag = {
  approved: 'approved',
  pending: 'pending',
  posted: 'posted',
  none: 'none',
}

const ManageApplicantActionType = {
  approve: 'approve',
  approveLast: 'approveLast',
  deny: 'deny',
}

export default {
 ShiftSubType,
 CardClassName,
 detailStatusTag,
 ManageApplicantActionType,
 ShiftCreationType,
};
